<template>
    <div v-if="computedItems.length" class="order-menu">
        <Dropdown class="order-menu__dropdown">
            <template #label>
                <div class="order-menu__button">
                    <IconDots fill="rgb(127, 127, 127)" class="order-menu__icon" />
                </div>
            </template>
            <template #items>
                <li v-for="item in computedItems" :key="item.id" class="dropdown__item">
                    <MenuItem :item="item" />
                </li>
            </template>
        </Dropdown>
    </div>
</template>

<script>
import Dropdown from '@speechki-frontend/shared/ui/Dropdown';
import { IconDots } from '@speechki-frontend/shared/ui/icons';
import MenuItem from './MenuItem';

export default {
    name: 'OrderMenu',
    components: {
        Dropdown,
        IconDots,
        MenuItem,
    },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        computedItems() {
            if (!this.items.length) return [];
            return this.items
                .filter(({ filter = () => true }) => filter())
                .map((item, i) => {
                    const { name, icon = null, params = {}, query = {}, options = {} } = item;
                    const id = `order-menu__item-${i}`;
                    const to = { name, params, query };
                    const label = item.label ? this.$t(item.label) : '';
                    const classes = ['order-menu__link', { 'order-menu__link--icon': !!icon }];

                    return {
                        ...item,
                        id,
                        to,
                        name,
                        label,
                        icon,
                        options,
                        classes,
                    };
                });
        },
    },
};
</script>

<style lang="scss" src="./OrderMenu.scss"></style>
